import {Box, Illustration, Stack, Text} from "@mbank-design/design-system/components";
import {GearWheelsCorporate} from "@mbank-design/design-system/illustrations";
import React, {useContext} from "react";
import {AppContext} from "../../shared/AppContext";

export default function ExpiredSpeakerInvitation() {
    const configuration = useContext(AppContext);
    
    return(
        <Box minWidth={[0, 1280]}>
            <Stack>
                <Illustration illustrationComponent={GearWheelsCorporate} />
                <Text as={"h2"}>invitation you are looking for has expired</Text>
                <Text as={"body"}>please contact us using email: <a href={'mailto:' + configuration.contactUsEmailAddress}>{configuration.contactUsEmailAddress}</a> </Text>
            </Stack>
        </Box>
    )
}